import { render, staticRenderFns } from "./MobileWait.vue?vue&type=template&id=35fd1879&scoped=true&"
var script = {}
import style0 from "./MobileWait.vue?vue&type=style&index=0&id=35fd1879&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fd1879",
  null
  
)

export default component.exports